import { render, staticRenderFns } from "./PrizeDetailFrame.vue?vue&type=template&id=24a5d5d4&scoped=true&"
import script from "./PrizeDetailFrame.vue?vue&type=script&lang=js&"
export * from "./PrizeDetailFrame.vue?vue&type=script&lang=js&"
import style0 from "./PrizeDetailFrame.vue?vue&type=style&index=0&id=24a5d5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5d5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a5d5d4')) {
      api.createRecord('24a5d5d4', component.options)
    } else {
      api.reload('24a5d5d4', component.options)
    }
    module.hot.accept("./PrizeDetailFrame.vue?vue&type=template&id=24a5d5d4&scoped=true&", function () {
      api.rerender('24a5d5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/PrizeDetailFrame.vue"
export default component.exports